import { safeDateParse } from '@/shared/infra/utils/utils';
import AmendmentStatus from '../../../application/domain/entities/AmendmentStatus';
import AmendmentStatusResponseDto from '../dto/res/AmendmentStatusResponseDto';

/**
 * Maps Amendment Status DTO to Entity
 * Corrects the API typo: "isAmendmetnInProgress" -> "isAmendmentInProgress"
 */
export const mapAmendmentStatusDtoToEntity = (dto: AmendmentStatusResponseDto): AmendmentStatus => ({
  isAmendmentInProgress: dto.isAmendmetnInProgress, // Fix API typo
  amendmentReason: dto.amendmentReason,
  amendmentCreationTimestamp: safeDateParse(dto.amendmentCreationTimestamp) as Date,
});

export default mapAmendmentStatusDtoToEntity;
